module.exports = __webpack_public_path__ + "static/media/roboto-v18-latin-ext_latin-300.3cb9e8d5.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/roboto-v18-latin-ext_latin-300.woff2
// module id = ./src/common/fonts/roboto-v18-latin-ext_latin-300.woff2
// module chunks = 1